import React from "react";
import { useEditorStore } from "../../../../state/editorStore";
import WatermarkTextFormatToolbar from "../Popup/WatermarkTextFormatToolbar";
import WatermarkImageFormatToolbar from "../Popup/WatermarkImageFormatToolbar";
import "./EditorTextFormatToolbar.css";

/**
 * Editor canvas toolbars — text or image formatting when watermark is on.
 */
const EditorTextFormatToolbar = () => {
  const watermark = useEditorStore((s) => s.object.watermark);
  const setWatermark = useEditorStore((s) => s.setWatermark);

  const mergeWatermark = (updates) => {
    const prev = useEditorStore.getState().object.watermark || {};
    setWatermark({ ...prev, ...updates, enabled: true });
  };

  if (!watermark?.enabled) return null;

  return (
    <>
      <WatermarkTextFormatToolbar
        watermark={watermark}
        onChange={mergeWatermark}
        visible
        keepEnabled
        className="editor-text-format-toolbar watermark-text-format-toolbar"
        anchorSelector=".editor-text-format-toolbar"
      />
      <WatermarkImageFormatToolbar
        watermark={watermark}
        onChange={mergeWatermark}
        visible
        keepEnabled
        className="editor-text-format-toolbar watermark-text-format-toolbar"
        toolKey="editor_watermark"
      />
    </>
  );
};

export default EditorTextFormatToolbar;
